module.exports = __webpack_public_path__ + "static/media/5.85150db7.jpg";